var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed top-0 left-0 right-0 bottom-0 z-50 bg-white"},[_c('audience-set-edit')],1)}
var staticRenderFns = []

export { render, staticRenderFns }